import { useState } from "react";
import ReactPlayer from "react-player";
import { TimelinePlayerContextValues } from "../context/TimelinePlayerContext";
import TimelinePositions from "../types/TimelinePositions";
import TimelineItem from "types/TimelineItem";

export default function useTimelinePlayerContextStates(): TimelinePlayerContextValues {
  const [absoluteTime, setAbsoluteTime] = useState(0);
  const [endTime, setEndTime] = useState<number>();
  const [comment, setComment] = useState<string>();
  const [fullscreen, setFullscreen] = useState<boolean>(false);
  const [isBeingModified, setIsBeingModified] = useState<boolean>(false);
  const [isScrubbing, setIsScrubbing] = useState<boolean>(false);
  const [currentTimelineItem, setCurrentTimelineItem] = useState<
    TimelineItem | undefined
  >();
  const [playbackRate, setPlaybackRate] = useState(1);
  const [playing, setPlaying] = useState<boolean>(false);
  const [player, setPlayer] = useState<ReactPlayer | undefined>();
  const [seekToAfterPlayerInit, setSeekToAfterPlayerInit] = useState<
    number | undefined
  >();
  const [seekToAbsolutePosition, setSeekToAbsolutePosition] = useState<
    number | undefined
  >();
  const [seekToRelativePosition, setSeekToRelativePosition] = useState<
    number | undefined
  >();
  const [startTime, setStartTime] = useState<number>();
  const [timelineItemId, setTimelineItemId] = useState<string | undefined>();
  const [timelineItemIndex, setTimelineItemIndex] = useState<number>(0);
  const [timelinePositions, setTimelinePositions] = useState<TimelinePositions>(
    new Map(),
  );
  const [totalDuration, setTotalDuration] = useState<number>(0);
  const [videoId, setVideoId] = useState<string>();

  return {
    absoluteTime,
    currentTimelineItem,
    comment,
    endTime,
    fullscreen,
    isBeingModified,
    isScrubbing,
    playbackRate,
    player,
    playing,
    seekToAbsolutePosition,
    seekToAfterPlayerInit,
    seekToRelativePosition,
    startTime,
    timelineItemId,
    timelineItemIndex,
    timelinePositions,
    totalDuration,
    videoId,

    setAbsoluteTime,
    setComment,
    setCurrentTimelineItem,
    setEndTime,
    setFullscreen,
    setIsBeingModified,
    setIsScrubbing,
    setPlaybackRate,
    setPlayer,
    setPlaying,
    setSeekToAbsolutePosition,
    setSeekToAfterPlayerInit,
    setSeekToRelativePosition,
    setStartTime,
    setTimelineItemId,
    setTimelineItemIndex,
    setTimelinePositions,
    setTotalDuration,
    setVideoId,
  };
}
